import vCheckboxRaw from './CheckboxRaw.vue';
import vCheckbox from './Checkbox.vue';

export { vCheckboxRaw, vCheckbox };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Checkbox/index.js